import { DOCUMENT, DestroyRef, Directive, ElementRef, inject } from '@angular/core';

/**
 * When its host goes away, gives focus back to the element that held it when the host was created:
 * the control that opened a panel docked away from it. Without this, closing the panel from inside
 * drops focus to the page body. Focus the user has already moved elsewhere is left alone.
 */
@Directive({
  selector: '[appReturnFocus]'
})
export class ReturnFocusDirective {
  constructor() {
    const document = inject(DOCUMENT);
    const host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    const opener = document.activeElement;
    inject(DestroyRef).onDestroy(() => {
      const active = document.activeElement;
      const lostWithHost = !active || active === document.body || host.contains(active);
      if (lostWithHost && opener instanceof HTMLElement && opener.isConnected) {
        opener.focus();
      }
    });
  }
}
